import $ from 'jquery';
import 'jquery-mousewheel';
import * as THREE from 'three';
import * as TWEEN from 'tween.js';
import * as d3 from 'd3';

import '../thirdparty/RequestAnimationFrame';
import Stats from '../thirdparty/Stats';
import LogTerminal, { log } from '../LogTerminal';

import '../thirdparty/d3.geo.robinson';

import '../three/CanvasRenderer';
import '../three/PinchZoomControls';
import '../three/Projector';
import '../three/TessellateModifier';
import '../three/TrackballControls';
import '../three/OrbitControls';

import '../jquery/jquery.doubleclick';
import '../jquery/jquery.easing.min';
import '../jquery/jquery.immybox';
import '../jquery/jquery.tipsy';

import '../jquery-ui/jquery-ui-1.12.0.custom/jquery-ui';
import '../jquery-ui/jquery-ui.custom.combobox';

import Config from '../config';
import { formatNumber, toSentenceStart, cleanURLString } from '../utils';
import * as CountryDataHelpers from '../utils/countryDataHelpers';
import * as Geometry from './geometry';
import * as Panels from './panel';
import * as UI from './userinterface';

THREE.Vector3.prototype.mix = function(v2, factor) {
  this.x = this.x + (v2.x - this.x) * factor;
  this.y = this.y + (v2.y - this.y) * factor;
  this.z = this.z + (v2.z - this.z) * factor;
};

if(!Date.now) Date.now = function() { return new Date().getTime(); };

export var worldMap;
var stats;
var timeoutCamera = null;

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}


function WorldMap() {

  this.geo;
  this.scene = {};
  this.renderer = {};
  this.camera = {};
  this.pointLight;
  this.stage = {};
  this.controls;
  this.projector;
  this.raycaster;
  this.clock;

  this.countries;
  this.cityList = {};
  this.centerPins = [];

  this.cameraDistance = Config.cameraDistance;
  this.desiredPosition = new THREE.Vector3(0, 0, 0);
  this.origin = new THREE.Vector3(0, 0, 0);
  this.cameraUpdate = false;

  this.selectedMapType = 'companies';
  this.selectedCountry = null;
  this.selectedOldCountry = null;
  this.visaInformationFound = false;
  this.selectedCity = null;
  this.selectedPin = null;

  this.sphere;
  this.globe;
  this.countriesObject3D;
  this.pinObject3D;

  this.intersectedObject = null;

  this.introRunning = true;

  this.inited = false;

  this.mode = 'destinations';
  this.viewMode = '3d';

  this.maxNumDestinationsFreeOrOnArrival = 0;
  this.maxNumSourcesFreeOrOnArrival = 0;
  this.maxGDP = 0;
  this.maxGDPPerCapita = 0;
  this.maxPopulation = 0;

  this.totalPopulation = 0;
  this.animationProps = {
    interpolatePos: 0.0,
    lineAnimatePos: 0.0,
    lineAnimateOffset: 0.0,
    colorChangeID: 0
  };

}

WorldMap.prototype = {

  initD3: function() {

    const GeoConfig = function() {

      this.projection = d3.geo.robinson();

      // this.projection = d3.geo.mercator(); // default, works
      // this.projection = d3.geo.equirectangular(); // works, needs scale = 0.2
      // this.projection = d3.geo.albers(); // works, needs scale = 0.2
      // this.projection = d3.geo.conicEqualArea(); // recommended for choropleths as it preserves the relative areas of geographic features.
      // this.projection = d3.geo.azimuthalEqualArea(); // also suitable for choropleths

      // var translate = this.projection.translate();
      // translate[0] = 0;
      // translate[1] = 80;

      // this.projection.translate(translate);

      // var rotate = [0, 0, 90];
      // this.projection.rotate(rotate);

      this.projection = this.projection.scale(Config.geoScale);

      this.path = d3.geo.path().projection(this.projection);

    };

    this.geo = new GeoConfig();
  },


  initThree: function() {

    if(Config.usesWebGL) {
      const canvas = document.querySelector('#container');
      this.renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true,
        alpha: true,
        clearAlpha: 0,
        clearColor: 0x000000,
        sortObjects: false
      });
      this.renderer.autoClear = false;
      // this.renderer.setClearColor( 0xBBBBBB, 1 );
      //log('WebGLRenderer, pixel ratio used: ' + this.renderer.getPixelRatio());
      this.renderer.setPixelRatio(window.devicePixelRatio || 1);

    } else {

      this.renderer = new THREE.CanvasRenderer({
        canvas: canvas,
        antialias: true,
        alpha: true,
        clearAlpha: 0,
        clearColor: 0x000000,
        sortObjects: false
      });
      //log('CanvasRenderer');
    }

    this.clock = new THREE.Clock();

    this.projector = new THREE.Projector();
    this.raycaster = new THREE.Raycaster();

    /* this.renderer.setSize( $(window).width(), $(window).height() );

    // append renderer to dom element
    $(Config.rendererContainer).append(this.renderer.domElement); */

    // create a scene
    this.scene = new THREE.Scene();

    /* this.scene.add( new THREE.AmbientLight( 0xffffff ) );

    this.pointLight = new THREE.PointLight(0x000000);
    this.pointLight.position.x = 0.0;
    this.pointLight.position.y = 500.0;
    this.pointLight.position.z = 1000.0;
    this.pointLight.intensity = 1.0;
    this.scene.add(this.pointLight); */

    this.scene.add(new THREE.HemisphereLight(0xffffff, 0xd4d4d4, 1));

    // var light1 = new THREE.DirectionalLight( 0xffffff, 0.5 );
    // light1.position.set( 1, 1, 1 );
    // this.scene.add( light1 );

    // var light2 = new THREE.DirectionalLight( 0xffffff, 1.5 );
    // light2.position.set( 0, -1, 0 );
    // this.scene.add( light2 );

    // put a camera in the scene
    this.camera = new THREE.PerspectiveCamera(Config.cameraFOV, $(window).width() / $(window).height(), 0.1, 20000);
    /* this.camera.position.x = 0.0;
    this.camera.position.y = 0.0;
    this.camera.position.z = Config.cameraDistance; */
    this.camera.position.copy(Config.cameraInitialPosition).normalize().multiplyScalar(this.cameraDistance)
    // this.camera.lookAt( { x: this.CAMERA_LX, y: 0, z: this.CAMERA_LZ} );
    this.scene.add(this.camera);

  },


  initControls: function() {
    // log('initControls()');

    /* this.controlsTrackball = new THREE.TrackballControls( this.camera, this.renderer.domElement );
    this.controlsTrackball.rotateSpeed = 0.5; // 1.0
    this.controlsTrackball.zoomSpeed = 1.0;
    this.controlsTrackball.panSpeed = 0.25;

    this.controlsTrackball.noRotate = false;
    this.controlsTrackball.noZoom = false;
    this.controlsTrackball.noPan = true;

    this.controlsTrackball.staticMoving = false;
    this.controlsTrackball.dynamicDampingFactor = 0.2;

    this.controlsTrackball.minDistance = Config.cameraDistanceMin;
    this.controlsTrackball.maxDistance = Config.cameraDistanceMax;

    this.controlsTrackball.keys = []; // [ 65 // A, 83 // S, 68 // D ]; // [ rotateKey, zoomKey, panKey ]
    this.controlsTrackball.enabled = false;

    // this.controlsTrackball.clearStateOnMouseUp = false;
    // this.controlsTrackball.setState(2);

    this.controlsPinchZoom = new THREE.PinchZoomControls( this.camera, this.renderer.domElement );
    this.controlsPinchZoom.staticMoving = true;
    this.controlsPinchZoom.minDistance = Config.cameraDistanceMin2D;
    this.controlsPinchZoom.maxDistance = Config.cameraDistanceMax;
    this.controlsPinchZoom.enabled = false; */

    this.controlsTrackball = new THREE.OrbitControls(this.camera, this.renderer.domElement);
    this.controlsTrackball.enableDamping = true;
    this.controlsTrackball.enablePan = false;
    this.controlsTrackball.enableZoom = false;
    this.controlsTrackball.minDistance = Config.cameraDistanceMinReal;
    this.controlsTrackball.maxDistance = Config.cameraDistanceMax;
    this.controlsTrackball.rotateSpeed = Config.cameraRotationSpeed;
    this.controlsTrackball.zoomSpeed = 1.0;
    this.controlsTrackball.enabled = false;

    this.controls = this.controlsTrackball;

  },


  setMode: function(mode) {
    this.mode = mode;

    UI.updateLegend(this);

    // UI.collapseNavBar();

    worldMap.clearBothSelectedCountries();

    worldMap.updateCountryColorsOneByOne();

    UI.updateModeStatement(worldMap);

  },


  createCountries: function() {
    //log('createCountries()');

    UI.updateLoadingInfo('Creating map ...');

    Geometry.createCountriesGeometry(this);

    Geometry.updateCountriesGeometry(this, true);

    worldMap.updateAllCountryColors();

    worldMap.animationProps.interpolatePos = 1.0;

    if(Config.usesWebGL) {
      Geometry.createCountriesBufferGeometry(this);
      Geometry.updateCountriesBufferGeometry(this);
    }

    let $this = this;
    window.setTimeout(function() {
      
      var scaleFinal = 1.0; // has to be one for the picking to work properly in combination with buffer geometry
      worldMap.tweenScale = new TWEEN.Tween(worldMap.countriesObject3D.scale)
        .to({x: scaleFinal, y: scaleFinal, z: scaleFinal}, Config.introRotateDuration) // 3500
        .delay(0)
        .onStart(function() {
          worldMap.animationProps.interpolatePos = 1.0;
        })
        .onUpdate(function() {
          worldMap.geometryNeedsUpdate = true;
        })
        .onComplete(function() {
          // worldMap.controls.enabled = true;
        })
        .easing(TWEEN.Easing.Quadratic.Out)
        // .easing(TWEEN.Easing.Cubic.Out)
        .start();

      worldMap.sphereTweenScale = new TWEEN.Tween(worldMap.globe.scale)
        .to({x: -scaleFinal, y: scaleFinal, z: -scaleFinal}, Config.introRotateDuration) // 3500
        .delay(0)
        .easing(TWEEN.Easing.Quadratic.Out)
        .start();

      window.setTimeout(function() {
        //worldMap.tweenWarp.start();
        //UI.showCountryList(worldMap);
        $this.showCenterPins();
        UI.updateModeStatement(worldMap); 
        UI.completeInit();
          worldMap.introRunning = false;
          worldMap.controls.enabled = true;
          //worldMap.showDisputedAreasBorders();
      }, Config.introWarpDelay);

      worldMap.tweenRotation = new TWEEN.Tween(worldMap.countriesObject3D.rotation)
        .to({ y: 0.0 }, Config.introRotateDuration) // 3500
        .delay(0)
        .easing(TWEEN.Easing.Quintic.Out)
        .onUpdate(function() {
          worldMap.geometryNeedsUpdate = true;
        })
        .start();

      /* worldMap.sphereTweenRotation = new TWEEN.Tween(worldMap.globe.rotation)
        .to({ x: (Math.PI * 0.2845),y: (-Math.PI * 0.5417) }, Config.introRotateDuration) // 3500
        .delay(0)
        .easing(TWEEN.Easing.Quintic.Out)
        .start(); */

    }, 100);


  },

  updateCountryColorsOneByOne: function() {
    //log('updateCountryColorsOneByOne()');

    if(this.selectedCountry) {
      let $this = this;

      $this.countries.forEach(function(country) {
        if(country == $this.selectedCountry) {
          if($this.selectedMapType == 'companies') {
            country.color = country.colorLast;
          } else if($this.selectedMapType == 'opportunity') {
            country.color = country.opportunityColor;
          } else if($this.selectedMapType == 'risk') {
            country.color = country.riskColor;
          }
          country.pinVisible = true;
          country.pinArray.forEach((pin) => {
            pin.marker.visible = true;
          });
        } else {
          country.color = Config.colorCountrySelected;
          if(country.pinVisible) {
            country.pinVisible = false;
            country.pinArray.forEach((pin) => {
              pin.marker.visible = false;
            });
          }
        }
      });
    }

    if(Config.usesWebGL) {
      Geometry.updateCountriesBufferGeometryColors(worldMap);
    }

  },

  updateAllCountryColors: function(pos) {
    //this.updateCountryColors(0, this.countries.length, pos);
  },

  resetCountryColors: function() {
    let $this = this;

    $this.countries.forEach(function(country) {
      if($this.selectedMapType == 'companies') {
        country.color = country.colorLast;
      } else if($this.selectedMapType == 'opportunity') {
        country.color = country.opportunityColor;
      } else if($this.selectedMapType == 'risk') {
        country.color = country.riskColor;
      }
      if(country.pinVisible) {
        country.pinVisible = false;
        country.pinArray.forEach((pin) => {
          pin.marker.visible = false;
        });
      }
    });

    if(Config.usesWebGL) {
      Geometry.updateCountriesBufferGeometryColors(worldMap);
    }
  },

  updateCountryColor: function () {
    let $this = this;
    if($this.selectedMapType == 'companies') {
      $this.selectedCountry.color = $this.selectedCountry.colorLast;
    } else if($this.selectedMapType == 'opportunity') {
      $this.selectedCountry.color = $this.selectedCountry.opportunityColor;
    } else if($this.selectedMapType == 'risk') {
      $this.selectedCountry.color = $this.selectedCountry.riskColor;
    }

    if(Config.usesWebGL) {
      Geometry.updateCountriesBufferGeometryColors(worldMap);
    }
  },

  switchMapType: function(type) {
    let $this = this;
    $this.selectedMapType = type;

    if($this.selectedCountry == null) {
      $this.resetCountryColors();
    } else {
      $this.updateCountryColor();
      UI.updateCountryInfo();
    }
    
    UI.updateLegend();
  },

  resetCamera: function() {
    let $this = this;
    $this.cameraUpdate = true;
    $this.cameraDistance = $this.controls.maxDistance;
    $this.desiredPosition = Config.cameraInitialPosition;
    if(timeoutCamera) clearTimeout(timeoutCamera);
    timeoutCamera = setTimeout(function(){$this.cameraUpdate = false;}, Config.timeoutCamera);
    //VAR.TrackInteraction(Config.contact_id, Config.other_id, 'APP WORLD', 'WEB_VISIT', 'Mappamondo', 'Confindustria Emilia Area Centro');
  },

  showDisputedAreasBorders: function() {
    /* for(var i = 0; i < this.countries.length; i++) {
      var country = this.countries[i];
      if(country.disputed) {
        if(this.viewMode === '2d') {
          this.scene.add(country.borderDisputed2D);
        } else {
          this.scene.add(country.borderDisputed3D);
        }
      }
    } */
  },

  hideDisputedAreasBorders: function() {
    /* for(var i = 0; i < this.countries.length; i++) {
      var country = this.countries[i];
      if(country.disputed) {
        this.scene.remove(country.borderDisputed2D);
        this.scene.remove(country.borderDisputed3D);
      }
    } */
  },

  updateCountryHover: function(country) {
    // log('updateCountryHover()');
    if(!Config.isTouchDevice) {
      this.intersectedObject = country.mesh;

      if(this.countryBorder) {
        this.scene.remove(this.countryBorder);
      }

      if(this.viewMode === '3d') {
        this.countryBorder = country.border3D;
        //this.countryBorder.scale.set(-1,-1,1);
      } else {
        this.countryBorder = country.border2D;
      }
      this.scene.add(this.countryBorder);

      if(this.listHover) {
        return;
      }

      if(country.listItem !== undefined) country.listItem.addClass('hover');

    }

  },

  clearCountryHover: function() {
    if(this.countryBorder) {
      this.scene.remove(this.countryBorder);
      this.countryBorder = null;
    }
    if(this.intersectedObject !== undefined && this.intersectedObject !== null) {
      if(this.intersectedObject.countryObject.listItem !== undefined) this.intersectedObject.countryObject.listItem.removeClass('hover');
    }
    this.intersectedObject = null;
  },

  updatePinHover: function(pin) {
    /* if(!Config.isTouchDevice) {
      this.intersectedObject = pin.mesh;

      if(this.viewMode === '3d') {
        this.countryBorder = country.border3D;
        //this.countryBorder.scale.set(-1,-1,1);
      } else {
        this.countryBorder = country.border2D;
      }
      this.scene.add(this.countryBorder);

      if(this.listHover) {
        return;
      }

    } */

  },

  clearPinHover: function() {
    if(this.countryBorder) {
      this.scene.remove(this.countryBorder);
      this.countryBorder = null;
    }
    if(this.intersectedObject !== undefined && this.intersectedObject !== null) {
      if(this.intersectedObject.countryObject.listItem !== undefined) this.intersectedObject.countryObject.listItem.removeClass('hover');
    }
    this.intersectedObject = null;
  },

  animate: function() {

    if(this.inited) {
      if(!Config.isTouchDevice && !this.introRunning && this.selectedCountry == null) {
        this.intersectedObjectBefore = this.intersectedObject;

        var intersects = Geometry.getIntersects(this, UI.mouseNormalized);

        if( intersects.length > 0 ) {
          // if( this.intersectedObject !== intersects[ 0 ].object && intersects[ 0 ].object.countryObject && intersects[ 0 ].object.countryObject !== this.selectedCountry ) {
          if( this.intersectedObject !== intersects[ 0 ].object && !this.listHover) {
            this.clearCountryHover();

            if(intersects[ 0 ].object.name !== 'sphere') {
              this.intersectedObject = intersects[ 0 ].object;
            }
            var country = intersects[ 0 ].object.countryObject;

            this.updateCountryHover(country);

          }

        } else {
          if(!this.listHover) {
            this.clearCountryHover();
            UI.hideCountryTooltip();
          }
        }

        if(this.intersectedObject) {
          $('body').css( 'cursor', 'pointer' );
        } else {
          $('body').css( 'cursor', 'default' );
        }
      }/*  else if(!Config.isTouchDevice && !this.introRunning && this.selectedCountry != null) {
        this.intersectedObjectBefore = this.intersectedObject;

        var intersects = Geometry.getIntersectsPin(this, UI.mouseNormalized);

        if( intersects.length > 0 ) {
          console.log(intersects[ 0 ]);
        }
      } */

      if(this.geometryNeedsUpdate) {
        Geometry.updateCountriesGeometry(this, false);
        if(Config.usesWebGL) {
          Geometry.updateCountriesBufferGeometry(this);
        }
      }

      if(this.selectedCountry) {
        Geometry.updateLines(this);
      }

      this.render();
    }

  },

  selectCountryFromMap: function(event) {
    //log('selectCountryFromMap');

    var intersects = Geometry.getIntersects(this, UI.mouseNormalizedTouchStart);

    if( intersects.length > 0 ) {
      if(intersects[ 0 ].object.countryObject && this.selectedCountry !== intersects[ 0 ].object.countryObject ) {

        // if(intersects[ 0 ].object.name !== 'sphere' && !intersects[ 0 ].object.countryObject.disputed) {
        if(intersects[ 0 ].object.name !== 'sphere') {
          this.setSelectedCountry(intersects[ 0 ].object.countryObject);
          this.trackEvent('sourceCountryMapClick', intersects[ 0 ].object.countryObject.name);

          this.updateCountryHover(intersects[ 0 ].object.countryObject);
          UI.centerCountryHoverInfoToMouse();
        }
      }
    } else {
      this.clearBothSelectedCountries();
    }

    //this.updateCountryColorsOneByOne();

  },

  selectPinFromMap: function(event) {
    var intersects = Geometry.getIntersectsPin(this, UI.mouseNormalizedTouchStart);

    if( intersects.length > 0 ) {
      if(intersects[ 0 ].object.name == 'cone' || intersects[ 0 ].object.name == 'conepin') {
        //codepin
        //cone = conepin -1
        var marker = intersects[ 0 ].object.parent;
        this.setSelectedPin({marker: marker, info: marker.info});
        UI.selectedPinMap();
      } else {
        this.selectCountryFromMap(event);
      }
    }
  },

  clearBothSelectedCountries: function() {
    // log('clearBothSelectedCountries()');

    if(this.selectedCountry || this.selectedDestinationCountry) {
      Geometry.deleteLinesObject(this);
      /* for(var i = 0; i < this.countries.length; i++) {
        this.countries[i].visa_required = '';
        this.countries[i].visa_title = '';
        this.countries[i].notes = '';
      } */
      if(this.selectedCountry) {
        if(this.selectedCountry.listItem !== undefined) this.selectedCountry.listItem.removeClass('selected');
      }
      this.selectedCountry = null;
      this.selectedCity = null;

      // UI.hideCountryTooltip();

      //UI.clearSourceCountryDropDown();

      //UI.clearDestinationCountryDropDown();

      UI.showMainLegend();

      UI.updateModeStatement(this);
    }

    UI.updateCountryList(this);

  },

  trackEvent: function(category, action) {
  },

  setSelectedCountry: function(selectedCountry) {
    //log('setSelectedCountry()');

    if(!this.introRunning) {
      this.selectedCountry = selectedCountry;

      //console.log(this.selectedCountry);

      if(this.viewMode == '3d') {

        //VAR.TrackInteraction(Config.contact_id, Config.other_id, 'APP WORLD', 'WEB_VISIT', 'Selected Country: '+this.selectedCountry.name, this.selectedCountry.name+' - Confindustria Emilia Area Centro');

        let $this = this;

        $this.hideCenterPins();
        $this.resetPinColor();

        $this.cameraUpdate = true;
        $this.cameraDistance = Config.cameraDistanceMin;
        if(timeoutCamera) clearTimeout(timeoutCamera);
        timeoutCamera = setTimeout(function(){$this.cameraUpdate = false;}, Config.timeoutCamera);
        $this.desiredPosition = $this.selectedCountry.center3D;
      }

      if(this.selectedCountry) {
        if(this.selectedCountry.listItem !== undefined) this.selectedCountry.listItem.addClass('selected');
      }

      this.updateCountrySelection();
    }
  },

  setSelectedCity: function(selectedCity) {

    if(!this.introRunning) {
      this.selectedCity = selectedCity;

      if(this.viewMode == '3d') {
        let $this = this,
          count = 0;

        if($this.selectedCity == 'All') {
          $this.selectedCountry.pinArray.forEach((pin) => {
            pin.marker.visible = true;
          });
          count = $this.selectedCountry.pinArray.length;
        } else {
          //VAR.TrackInteraction(Config.contact_id, Config.other_id, 'APP WORLD', 'WEB_VISIT', 'Selected City: '+this.selectedCity+'('+this.selectedCountry.name+')', this.selectedCity+'('+this.selectedCountry.name+')'+' - Confindustria Emilia Area Centro');

          $this.selectedCountry.pinArray.forEach((pin) => {
            if(pin.info.city == $this.selectedCity) {
              pin.marker.visible = true;
              count++;
            } else pin.marker.visible = false;
          });
        }

        UI.setSelectedCity(count);
      }
    }
  },

  setSelectedPin: function(selectedPin) {

    if(!this.introRunning) {
      this.selectedPin = selectedPin;

      if(this.viewMode == '3d') {
        let $this = this;

        //VAR.TrackInteraction(Config.contact_id, Config.other_id, 'APP WORLD', 'WEB_VISIT', 'Selected Company: '+this.selectedPin.info.name_country+'('+this.selectedPin.info.name+') - '+this.selectedPin.info.city+'('+this.selectedCountry.name+')', this.selectedPin.info.name_country+'('+this.selectedPin.info.name+') - '+this.selectedPin.info.city+'('+this.selectedCountry.name+')'+'- Confindustria Emilia Area Centro');

        $this.updatePinColor($this.selectedPin.marker);

        $this.cameraUpdate = true;
        if(timeoutCamera) clearTimeout(timeoutCamera);
        timeoutCamera = setTimeout(function(){$this.cameraUpdate = false;}, Config.timeoutCamera);
        let position = new THREE.Vector3();
        position.copy($this.selectedPin.marker.position);
        //$this.selectedPin.marker.position.copy(position);
        position.x = -1 * position.x;
        position.z = -1 * position.z;

        $this.desiredPosition = position;

        UI.updateCompany($this.selectedPin.info);
      }

      /* if(this.selectedCountry) {
        if(this.selectedCountry.listItem !== undefined) this.selectedCountry.listItem.addClass('selected');
      } */

      //this.updateCountrySelection();
    }
  },

  setSelectedSearch: function(selectedCountry, selectedPin) {
    if(!this.introRunning) {
      this.selectedCountry = selectedCountry;
      this.selectedPin = selectedPin;

      if(this.viewMode == '3d') {
        let $this = this;

        $this.hideCenterPins();
        $this.updatePinColor($this.selectedPin.marker);

        $this.cameraUpdate = true;
        $this.cameraDistance = Config.cameraDistanceMin;
        if(timeoutCamera) clearTimeout(timeoutCamera);
        timeoutCamera = setTimeout(function(){$this.cameraUpdate = false;}, Config.timeoutCamera);
        let position = new THREE.Vector3();
        position.copy($this.selectedPin.marker.position);
        position.x = -1 * position.x;
        position.z = -1 * position.z;

        $this.desiredPosition = position;
        
        if($this.selectedCountry) {
          if($this.selectedCountry.listItem !== undefined) $this.selectedCountry.listItem.addClass('selected');
        }

        $this.updateCountrySelection();

        UI.updateCompany($this.selectedPin.info);
        //UI.hideZoom();
      }

      
    }
  },

  updatePinColor: function() {
    if(this.selectedCountry && this.selectedPin) {
      let $this = this;
      $this.selectedCountry.pinArray.forEach(function(pin) {
        if(pin.marker.id == $this.selectedPin.marker.id) {
          pin.marker.scale.set(1.5,1.5,1.5);
          pin.marker.children[0].material.color.set(Config.colorPinSelected);
          pin.marker.children[1].material.color.set(Config.colorPinSelected);
        } else {
          if(JSON.stringify(pin.marker.children[0].material.color) === JSON.stringify(Config.colorPinSelected)) {
            pin.marker.scale.set(1,1,1);
            pin.marker.children[0].material.color.set(Config.pinColors[pin.info.type]);
            pin.marker.children[1].material.color.set(Config.pinColors[pin.info.type]);
          }
        }
      });
    }

    /* if(Config.usesWebGL) {
      Geometry.updateCountriesBufferGeometryColors(worldMap);
    } */

  },

  resetPinColor: function() {
    if(this.selectedPin) {
      this.selectedPin.marker.scale.set(1,1,1);
      this.selectedPin.marker.children[0].material.color.set(Config.pinColors[this.selectedPin.info.type]);
      this.selectedPin.marker.children[1].material.color.set(Config.pinColors[this.selectedPin.info.type]);
    }
  },

  hideCenterPins: function() {
    let $this = this;

    $this.centerPins.forEach((pin) => {
      pin.visible = false;
    });
  },

  showCenterPins: function() {
    let $this = this;

    $this.centerPins.forEach((pin) => {
      pin.visible = true;
    });
  },

  setSelectedDisputedCountry: function(country) {
    /* if(!this.introRunning) {
      this.selectedCountry = country;
      UI.setHeadline( country.name );
    } */
  },

  setSelectedDisputedDestinationCountry: function(country) {
    /* if(!this.introRunning) {
      this.selectedDestinationCountry = country;
      UI.setHeadline( country.name );
    } */
  },

  updateCountrySelection: function() {
    UI.setSelectedCountry();
    // log('updateCountrySelection()');

    //UI.updateCountryList(this);
    if(Config.usesWebGL) {
      Geometry.createLines(this);
    }
    this.updateCountryColorsOneByOne();
  },

  render: function() {

    this.renderer.render(this.scene, this.camera);

    if(this.controls) {
      this.controls.update();
    }

    if(this.cameraUpdate) {
      let camPos = this.camera.position;
      camPos.lerp(this.desiredPosition, 0.1);
      this.camera.position.copy(camPos).normalize().multiplyScalar(this.cameraDistance);
      this.camera.lookAt(this.origin);
    }

    /*
    this.pointLight.position.x = this.camera.position.x;
    this.pointLight.position.y = this.camera.position.y + 300;
    this.pointLight.position.z = this.camera.position.z;
    */

  }
}; /* WorldMap end */


function init() {

  /* if(!Config.logTerminalVisible) {
    LogTerminal.hide();
  } */

  if(Config.statsVisible) {
    stats = new Stats();
    stats.domElement.style.position = 'fixed';
    stats.domElement.style.top = '0px';
    stats.domElement.style.right = '0px';
    $('body').append( stats.domElement );
  }

  Panels.initPanels();

  UI.bindWindowResizeHandler();
  UI.centerCountryHoverInfoToScreen();
  UI.createLoadingInfo();

  worldMap = new WorldMap();

  worldMap.initD3();
  worldMap.initThree();

  if(Config.sphereEnabled) {
    Geometry.createSphere(worldMap);
  }

  // log('Loading world map ...');
  UI.updateLoadingInfo('Loading world map ...');

  $.when( $.getJSON(Config.saceDataFile) ).then(function(dataCountries) {
    //log('sace map loaded.');
    worldMap.saceData = dataCountries;

    $.when( $.getJSON(Config.mapDataFile) ).then(function(dataCountries) {
      //log('World map loaded.');
      worldMap.dataCountries = dataCountries;
      completeInit();
    });
  });

  function animate() {
    requestAnimationFrame(animate);

    if(worldMap !== undefined) worldMap.geometryNeedsUpdate = false;

    if(stats !== undefined) stats.update();

    TWEEN.update();

    if(worldMap !== undefined) worldMap.animate();
  }
  animate();

} /* init() end */


function completeInit() {
  worldMap.createCountries();
  worldMap.initControls();

  UI.init(worldMap);

  worldMap.inited = true;
}

$(document).ready(init);
